export enum LocalMessageStoreEventType {
  // every timer tick (100 ms) while a timed card exists
  Tick = 'tick',
  // a push with a known collapseKey bumped the card to ×N
  Bump = 'bump',
  // update() rebuilt the card content
  Morph = 'morph',
}
